<template>
  <div class="text-sm text-gray-800 space-y-1">
    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Título:</span>
      <span class="text-gray-900 font-semibold">{{ configPage.settings.title }}</span>
    </div>
    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Subtítulo:</span>
      <span class="text-gray-900 font-semibold">{{ configPage.settings.subtitle }}</span>
    </div>
    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Descripción:</span>
      <span class="text-gray-900 font-semibold">{{ configPage.settings.description }}</span>
    </div>

    <div class="flex flex-wrap justify-between items-center gap-1">
      <div class="w-10 h-10 bg-gray-200 rounded-sm overflow-hidden text-xs text-gray-400 flex items-center justify-center mr-3">
        <img class="w-full h-full object-cover rounded-sm"
        :src="imageSrc"
        @error="onImageError"
        :alt="imageAlt">
      </div>

      <div class="flex-grow">
        <h2 class="text-gray-800 font-medium">
          Imagen de portada
        </h2>

        <ul class="flex flex-wrap items-center whitespace-nowrap gap-2">
          <li class="inline-flex items-center relative">
            <p class="font-medium text-gray-600">
              Visible:
            </p>
          </li>
          <li class="inline-flex items-center relative">
            <p class="text-gray-900 font-semibold">
              {{ configPage.visible ? 'Sí' : 'No' }}
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div class="flex gap-x-2">
      <span class="font-medium text-gray-600">Página visible:</span>
      <span class="text-gray-900 font-semibold">{{ configPage.visible ? 'Sí' : 'No' }}</span>
    </div>
  </div>
</template>

<script>
import { readFileAsDataURL } from '../services/helpers.service.js';

export default {
  name: "PageCoverDisplay",

  props: {
    configPage: {
      type: Object,
      required: true
    },
    activityGroups: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      imageSrc: '',
      imageAlt: '',
      fallbackImage: '/images/default-cover.png',
      s3bucket: window.config.s3bucket,
    };
  },

  mounted() {
    this.loadImage();
  },

  methods: {
    async loadImage() {
      try {
        this.imageSrc = await this.getSourceImage();
      } catch (e) {
        this.imageSrc = this.fallbackImage;
      }
    },

    onImageError() {
      this.imageSrc = this.fallbackImage;
    },

    async getSourceImage() {
      const imageCover = this.configPage?.settings?.image_cover;

      if (!imageCover) {
        return this.fallbackImage;
      }

      if (imageCover.type === 'url' && imageCover.url) {
        return `//${this.s3bucket}/${imageCover.url}?t=${Date.now()}`;
      }

      if (imageCover.file) {
        return await readFileAsDataURL(imageCover.file);
      }

      return this.fallbackImage;
    },

  }
}
</script>
